import { Bone } from "@/components/Bone";
import { BOARD_HEIGHT_PX } from "@/components/PlanningBoard";
import { BoneLine, BonePanel, BoneTitle, Skeleton } from "@/components/PageSkeleton";

import styles from "./PlanningScreen.module.css";

/** The region's name for a screen reader while the board loads. */
export const PLANNING_LOADING = "Planung wird geladen";

/**
 * The board's page in its own geometry while the plan and the Vorgang load
 * (Task 10; UX review 26.10.2026, B-4), built from the board page's classes:
 * the work area with its head band (title, steps, save line — UX-Gutachten 2,
 * B-6), the tool row with the job's facts, the tool's line over the board
 * (in the flow again since fix round 1 of Task 15, I-1 — without its bone the
 * board jumped 28 px on load), the board at its fixed height and the
 * inspector beside it. The frame stands above with the Vorgang's name; the
 * page lands where its bones were — the same sections in the same order
 * (PlanningScreen.test.tsx holds it).
 */
export function PlanningSkeleton() {
  return (
    <Skeleton label={PLANNING_LOADING} className={styles.screen}>
      <div className={styles.work} aria-hidden="true">
        {/* The work's head (UX-Gutachten 2, B-6): title, steps, save state. */}
        <div className={styles.strip}>
          <BoneTitle className={styles.title} width="8rem" />
          <div className={styles.steps}>
            <div className={styles.stepList}>
              {[0, 1, 2].map((step) => (
                <Bone key={step} height="3.375rem" />
              ))}
            </div>
          </div>
          <BoneLine className={styles.saveState} width="9rem" />
        </div>
        {/* Tools, the job's facts with „Form ändern …", the actions. */}
        <div className={styles.toolRow}>
          <Bone width="21rem" height="2.5rem" />
          <div className={styles.jobFacts}>
            <Bone width="22rem" height="2.5rem" />
          </div>
          <Bone width="16rem" height="2.5rem" />
        </div>
        {/* The tool's line over the board. */}
        <div className={styles.status}>
          <BoneLine width="24rem" />
        </div>
        <div className={styles.workspace}>
          <Bone height={`${BOARD_HEIGHT_PX}px`} />
          <div className={styles.side}>
            <BonePanel>
              <Bone width="5rem" />
              <Bone height="12rem" />
            </BonePanel>
            <BonePanel>
              <Bone width="4rem" />
              <Bone width="90%" />
              <Bone height="2.5rem" />
            </BonePanel>
          </div>
        </div>
      </div>
    </Skeleton>
  );
}
